/**
 * Shared keyboard-shortcut guards for the admin shell (spec C2/C3,
 * 2026-07-09 wave).
 *
 * The shell binds single-key shortcuts (`/` focuses search, `b` opens
 * Quick Book). Those must NEVER fire while the user is typing somewhere —
 * a receptionist writing "b" into a booking note is not asking for a
 * modal. One predicate, used by every shortcut, so the guard can't drift
 * between them.
 */

/**
 * Is the event target a text-entry surface (input, textarea, select, or
 * any contentEditable element)? Fails closed for non-HTMLElement targets
 * (window, document) — those are NOT text entry, so shortcuts fire.
 */
export function isTextEntryTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}
